import React from 'react';
import { Link } from 'react-router-dom';

import styles from './NoMatch.module.scss';

import logo from '../../assets/images/logo-full-color.png';

const NoMatch = () => {
  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <div className={styles.logoContainer}>
          <Link to={'/'}>
            <img className={styles.logo} src={logo} alt="logo" />
          </Link>
        </div>
      </header>
      <div className={styles.content}>
        <span className={styles.titleText}>404 Not Found</span>
      </div>
    </div>
  );
};

export default NoMatch;
